import { FunctionComponent } from 'react';
import { AvailabilityIndicator, BodyText, SupportedBodyTextSize } from '@gaiads/telia-react-component-library';
import { SupportedTextColor } from '@gaiads/telia-react-component-library/build/types/components/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { ApprovalStatus } from '@cdaas/api-clients/dist/order-openapi';

import { getAvailabilityColor, handleApprovalStatusMappingToFrontendEnum } from '../../utils';

interface ApprovalStatusIndicatorProps {
  status: ApprovalStatus;
  textColor?: SupportedTextColor;
  additionalText?: string;
  textSize?: SupportedBodyTextSize; // Can be plain text or key to be translated(approval namespace used)
}

const ApprovalStatusIndicator: FunctionComponent<ApprovalStatusIndicatorProps> = ({
  status,
  textColor = 'black',
  additionalText,
  textSize = 'md',
}) => {
  const { t } = useTranslation('approval');
  return (
    <AvailabilityIndicator color={getAvailabilityColor(handleApprovalStatusMappingToFrontendEnum(status))}>
      <BodyText color={textColor} size={textSize}>
        {t(`ApprovalList.orderStatusOptions.${handleApprovalStatusMappingToFrontendEnum(status)}`) +
          (additionalText ? ' ' + t(`${additionalText}`) : '')}
      </BodyText>
    </AvailabilityIndicator>
  );
};

export default ApprovalStatusIndicator;
